import { Col, Row } from "antd";
import React from "react";
import BackBtnComponent from "../BackBtn/BackBtnComponent";
import NextStepBtnComponent from "../NextStepBtn/NextStepBtnComponent";
import "./NextBackBtnComponent.scss";
import { INextBackBtnComponentProps } from "./NextBackBtnInterfaces.types";

function NextBackBtnComponent(props: INextBackBtnComponentProps) {
  return (
    <div className={'NextBackBtn ' + (props.className || '' )} >
      <Row justify="center" align="middle" className={props.rowClassName}>
        <Col style={{ width: "50%" }}>
          <BackBtnComponent
            label={"Volver"}
            title="Volver atrás"
          ></BackBtnComponent>
        </Col>
        <Col style={{ width: "50%" }}>
          <NextStepBtnComponent
            id={props.id}
            value={props.value}
            text={"Siguiente"}
            action={() => {
              alert("Clicked");
            }}
          />
        </Col>
      </Row>
    </div>
  );
}

export default NextBackBtnComponent;
